import styled from 'styled-components/macro';
import { colorCoreBlack900Base, colorCoreGray500, colorBlackTransparent50, defaultTransparent, customGradientFromWhiteToTransparent90deg, customGradientFromWhiteToTransparent270deg, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { GUTTER_BETWEEN_TABS } from './constants';
export const TabsWrapper = styled(FlexWrapper) `
  position: relative;
  flex-direction: row;
  align-items: flex-start;

  border-bottom: 1px solid ${colorCoreGray500};
  white-space: nowrap;
  overflow: hidden;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 56px;

    z-index: ${Z_INDEX.level1};
  }

  &::before {
    left: 0;
    background: ${customGradientFromWhiteToTransparent90deg};
  }

  &::after {
    right: 0;
    background: ${customGradientFromWhiteToTransparent270deg};
  }

  ${({ isShowLeftGradient }) => isShowLeftGradient && '&::before { content: initial; }'}
  ${({ isShowRightGradient }) => isShowRightGradient && '&::after { content: initial; }'}
`;
export const TabsInner = styled.div `
  position: relative;
  flex-direction: row;
  align-items: flex-start;

  animation: slide 0.7s forwards;
  animation-delay: 2s;
  transition: translateX 1.5s, transform 1.5s;

  ${({ transformOption }) => `transform: translateX(${transformOption}px);`}
`;
export const TabItem = styled.div `
  padding: 12px 8px 11px;
  cursor: pointer;

  border-bottom-style: solid;
  border-bottom-width: 1px;

  border-color: ${({ isActiveTab, colorTheme }) => isActiveTab ? colorTheme : defaultTransparent};

  margin-left: ${GUTTER_BETWEEN_TABS / 2}px;
  margin-right: ${GUTTER_BETWEEN_TABS / 2}px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    border-color: ${colorCoreBlack900Base};
    background-color: ${colorBlackTransparent50};
  }
`;
export const TabTitleStyled = styled(RegularTextLevel3) `
  display: flex;
  gap: 8px;
  align-items: center;
`;
export const TabAmountStyled = styled(RegularTextLevel4) `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  padding: 4px;
  background-color: ${colorBlackTransparent50};
  border-radius: ${CORNER_RADIUS.circle};
`;
